module.exports = __webpack_public_path__ + "static/media/14.932b47f9.jpg";